import type { CipherText } from "@b2bportal/purchase-api";

export enum PaymentEvent {
  // CommonEvents
  NEXT = "NEXT",
  PREVIOUS = "PREVIOUS",

  SET_PAYMENT_DATA_AND_GO_NEXT = "SET_PAYMENT_DATA_AND_GO_NEXT",
  ADD_PAYMENT_TO_FULFILL = "ADD_PAYMENT_TO_FULFILL",
}

export interface NextEvent {
  type: PaymentEvent.NEXT;
}
export interface PreviousEvent {
  type: PaymentEvent.PREVIOUS;
}
export interface SetPaymentDataAndGoNext {
  type: PaymentEvent.SET_PAYMENT_DATA_AND_GO_NEXT;
  paymentQuoteToken: CipherText;
  paymentSessionToken: string;
}

export interface AddPaymentToFulfill {
  type: PaymentEvent.ADD_PAYMENT_TO_FULFILL;
}

export type UberPaymentEvents =
  | NextEvent
  | PreviousEvent
  | SetPaymentDataAndGoNext
  | AddPaymentToFulfill;
